import { useQuery } from "@tanstack/react-query";
import { getPayoutStats } from "services/dashboard.service";

// period: 7d | 14d | 30d | 60d | 90d (default 30d)
export const usePayoutStats = (period = "30d", options = {}) => {
  return useQuery({
    queryKey: ["payout-stats", period],
    queryFn: () => getPayoutStats(period),
    select: (res) => res?.data ?? null,
    ...options,
  });
};
